import { Injectable } from '@angular/core';
import sdk from '@sp400/sdk'
import { Subject } from "rxjs";
import { CacheService } from "./cache.service";
import { SdkService } from './sdk.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedInStatus: boolean = false;
  loggedInObservable: Subject<boolean> = new Subject<boolean>();

  constructor(private sdkService: SdkService) {
  }

  login(userId: string, password: string): Promise<any> {
    return this.sdkService.set('authentication.login', {
      loginID: userId,
      password: password
    }, false);
  }

  logout(): Promise<any> {
    return this.sdkService.set('authentication.logout', null);
  }

  forgotPassword(email: string): Promise<any> {
    return this.sdkService.set('authentication.forgotPassword', {
      loginID: email
    });
  }

  setIsLogged(value: boolean) {
    this.loggedInStatus = value;
    this.loggedInObservable.next(this.loggedInStatus);
  }

  hasSession(): boolean {
    return this.loggedInStatus;
  }
}
